export const FETCH_SLIPS = 'FETCH_SLIPS'
export const ADD_SLIPS = 'ADD_SLIPS'
export const UPDATE_SLIPS = 'UPDATE_SLIPS'
export const REMOVE_SLIPS = 'REMOVE_SLIPS'
export const GET_SLIP = 'GET_SLIP'

